import React, {useCallback, useMemo} from 'react';
import BigTooltip from "../../Tooltip/BigTooltipBox";
import styled from "styled-components";
import {useTranslation} from "react-i18next";

const ReletiveDiv = styled.div`
  position: relative;
  margin: ${props => props.margin};
  border: 1px solid #0C0C0C;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ChampionImage = styled.img``;

const AbsoluteSpan = styled.span`
  text-align: center;
  width: 2.5ch;
  position: absolute;
  padding: 2px;
  font-size: 12px;
  color: #fff;
  background-color: #232734;
  bottom: 0;
  right: 0;
`;

const ChampionSkillImage = ({version, img, absoluteText, width = 36, height = 36, margin, reverse, spell,children}) => {
    const {i18n,t} = useTranslation();
    const getAllEqualsArray = useCallback((array) => {
        if (Array.isArray(array) && array.length > 0) {
            const every = array.every((data) => data === array[0]);
            if (every) {
                return array[0].toString()
            } else {
                return array.toString().replaceAll(',', " / ");
            }
        }
        return [];
    }, []);

    const tooltipText = useMemo(() => {
        if (spell) {
            const isKorean = ['ko','ko-KR'].includes(i18n.language);
            const name = isKorean ? spell.spell_name_kr : spell.spell_name_en;
            const cooldown = getAllEqualsArray(spell.cooldown);
            const cost = getAllEqualsArray(spell.cost);
            const range = getAllEqualsArray(spell.range);
            const description = isKorean ? spell.tooltip_kr : spell.tooltip_en;
            return `<span style="color: #46B9AA; font-weight: bold">${name}</span>\n${t("skills.cooldown")}: ${cooldown}\n${t("skills.cost")}: ${cost}\n${t("skills.range")}: ${range}\n\n${description}`
        }

    }, [spell,i18n.language])

    return (
        <ReletiveDiv margin={margin}>
            <BigTooltip
                reverse={reverse}
                tooltipText={tooltipText}>
                <ChampionImage
                    loaindg={'lazy'}
                    width={width}
                    height={height}
                    src={`${process.env.REACT_APP_IMG}${version}/img/spell/${img}`}
                />
                {absoluteText && <AbsoluteSpan>{absoluteText}</AbsoluteSpan>}
            </BigTooltip>
            {children && React.cloneElement(children,{spell})}
        </ReletiveDiv>
    );
};

export default ChampionSkillImage;
